import { useState } from "react";
import { Icon } from "../../components/ui/Icon";

export interface PickItem {
  value: string;
  label: string;
  /** Shown on the right, like a dial code. */
  hint?: string;
}

/** A full list to pick one from, with a search at the top; the one in use is ticked. */
export function PickList({ items, value, onPick, label }: { items: PickItem[]; value: string; onPick: (v: string) => void; label: string }) {
  const [q, setQ] = useState("");
  const needle = q.trim().toLowerCase();
  const shown = needle ? items.filter((o) => o.label.toLowerCase().includes(needle) || (o.hint ?? "").includes(needle)) : items;

  return (
    <>
      <div className={q ? "mo-find q" : "mo-find"}>
        <label className="pn-search">
          <Icon name="search" />
          <input type="search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search" aria-label={`Search ${label.toLowerCase()}`} autoComplete="off" enterKeyHint="search" />
        </label>
        <button
          type="button"
          className="mo-fx"
          onMouseDown={(e) => e.preventDefault()}
          onClick={(e) => {
            setQ("");
            e.currentTarget.parentElement?.querySelector("input")?.blur();
          }}
        >
          Cancel
        </button>
      </div>
      {shown.length > 0 ? (
        <div className="pn-grp" role="listbox" aria-label={label}>
          {shown.map((o) => (
            <button key={`${o.value}|${o.label}`} type="button" role="option" aria-selected={o.value === value} className="pn-row" onClick={() => onPick(o.value)}>
              <span className="m">
                <span className="t">{o.label}</span>
              </span>
              {o.hint && <span className="v">{o.hint}</span>}
              {o.value === value && (
                <span className="mo-tick">
                  <Icon name="check" />
                </span>
              )}
            </button>
          ))}
        </div>
      ) : (
        <div className="pn-empty">
          <b>No match</b>
          Try another name.
        </div>
      )}
    </>
  );
}
